import { CSSProperties, FC, ReactNode } from 'react';

export type DynamicHeadingProps = {
  isMainHeading: boolean;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  htmlContent?: string;
};

export const DynamicHeading: FC<DynamicHeadingProps> = ({
  isMainHeading,
  className,
  children,
  style,
  htmlContent,
}) => {
  const HeadingTag = isMainHeading ? 'h1' : 'h2';

  if (htmlContent) {
    return (
      <HeadingTag
        className={className}
        style={style}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }
  return (
    <HeadingTag className={className} style={style}>
      {children}
    </HeadingTag>
  );
};
